import { CisCustomerVoucherType, CisQueryType } from "@tm/models"

export type ShowCisOptionsRequest = {
    customerNo?: string
}

export type ShowCisOptionsResponse = {
    dateFilterDayPreset?: number
    displayBehaviour: DisplayBehaviour
    queryTypes?: CisQueryType[]
    returnReasons?: ReturnReason[]
    cisFunctions?: CisFunction[]
    hasErrors: boolean
    errorMessage: string
}

export type CisFunction = CisFunctionStandard | CisFunctionVoucher

type CisFunctionStandard = {
    functionType: Exclude<CisFunctionType, CisFunctionType.Vouchers>
    urlKey: string
}

export type CisFunctionVoucher = {
    functionType: CisFunctionType.Vouchers
    voucherType: CisCustomerVoucherType
    urlKey: string
}

export enum DisplayBehaviour {
    None = 0,
    ClassicWidget = 1,
    ExtendedWidget = 2,
    SelectionWidget = 3,
    StartPage = 514,
    Dashboard = 515,
    StartPageAndDashboard = 516,
    Basket = 519,
    Header = 521,
    Module = 523,
    DashboardAndHeader = 525,
}

export type ReturnReason = {
    id?: number
    description?: string
    isReturnInfoRequired?: boolean
}

/// <summary>
/// Additional Information for Type 1 (Vouchers):
/// Cis.ShowOpenOrders (VoucherTypeId == 8) //reserved for STG
/// Cis.ShowCompletedOrders (VoucherTypeId == 9) //reserved for STG
/// Cis.ShowOrdersByArticle (VoucherTypeId == 10) //reserved for STG
/// Cis.ShowAllOrders (VoucherTypeId == 15) //reserved for PV
/// Cis.ShowComplaints (VoucherTypeId == 11)
/// Cis.FindVouchers (VoucherTypeId between 2 and 99 and not listed in the above cases)
/// </summary>
export enum CisFunctionType {
    None = 0,
    Vouchers = 1, // Cis.FindVouchers and other (see summary above): Multiple voucher types dynamically
    Summary = 2, // Cis.ShowCustomers
    ReturnOfGoods = 3, // Cis.ShowReturnItems
    Invoices = 4, // Cis.FindInvoices
    Backorders = 5, // Cis.ShowBackorders
    DeliveryTours = 6, // Cis.ShowTours
    StatementOfCosts = 7, // RepairShops.GetCalculatedCostTypesRepair
}
